import React from "react";
import { Button } from "../../../../components/ui/button";

export const FooterSection = (): JSX.Element => {
  const aboutLinks = ["Feature", "Pricing", "Contact"];
  
  return (
    <div id="contact" className="w-full px-4 md:px-6 py-4">
      <footer className="bg-black text-white rounded-3xl px-6 md:px-8 py-8 md:py-12 w-full max-w-[1920px] mx-auto relative overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: "url('/blue-glossy-shape-cut-out-on-black-background-2 1.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            opacity: 0.4
          }}
        />

        {/* Asphalt Texture Overlay */}
        <div 
          className="absolute inset-0 z-20 opacity-30"
          style={{
            backgroundImage: "url('/asfalt--light--1920x1080.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            mixBlendMode: "overlay"
          }}
        />

        <div className="max-w-7xl mx-auto relative z-30">
          {/* Newsletter Section */}
          <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-6 mb-12">
            <h2 className="text-2xl md:text-3xl font-satoshi font-bold max-w-md">
              Subscribe to our newsletter to get our latest updates
            </h2>
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                placeholder="Enter your email address"
                className="bg-[#1A1A1A] text-white px-4 py-2 rounded-lg w-full sm:w-[280px] focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <Button className="bg-[#4B6BFB] hover:bg-[#3951C6] text-white px-6 py-2 rounded-lg w-full sm:w-auto">
                Subscribe
              </Button>
            </div>
          </div>

          {/* Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6 mb-12">
            {/* Brand Section */}
            <div className="col-span-1">
              <div className="flex items-center gap-2 mb-3">
                {/* <div className="w-7 h-7 bg-white rounded-lg" />  */}
                <span className="font-panchang font-bold text-lg">Safora</span>
              </div>
              <p className="text-gray-400 text-sm">
                Effortless payroll, seamless success simplify your pay process today.
              </p>
            </div>

            {/* About Section */}
            <div className="col-span-1">
              <h3 className="font-satoshi font-bold mb-4">About</h3>
              <ul className="space-y-2">
                {aboutLinks.map((link, index) => (
                  <li key={index}>
                    <a href="#" className="text-gray-400 hover:text-white transition-colors">
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Section */}
            <div className="col-span-1 lg:col-span-2">
              <h3 className="font-satoshi font-bold mb-4">Contact</h3>
              <div className="space-y-2 text-gray-400">
                <p>purvvirpariya14@gmail.com</p>
                <p>+91 12345 67890</p>
                <p>Vrajbhumi Sec-2,Surat,IND</p>
              </div>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs md:text-sm text-gray-400">
            <p>Copyright © 2024 Safora. All rights reserved</p>
            <div className="flex gap-4 md:gap-6">
              <a href="#" className="hover:text-white transition-colors">Terms and Conditions</a>
              <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};